export const MASK_WIDTH = 192;
export const MASK_HEIGHT = 256;
export const STAGE_THRESHOLD = 0.96;
export const TOOL_RADII = [18, 10, 15, 22] as const;
export const TOOL_NAMES = ['吸塵器', '縫隙刷', '泡沫噴壺', '水槍'] as const;
export const STAGE_INSTRUCTIONS = [
  '拖動吸塵器清除表面灰塵',
  '用縫隙刷清理濾網縫隙',
  '噴上清潔泡沫帶走油灰',
  '用水槍沖洗乾淨',
] as const;
export const STORAGE_KEY = 'stress-clear-h5-save-v1';

export type ToolIndex = 0 | 1 | 2 | 3;

export function isToolIndex(value: number): value is ToolIndex {
  return Number.isInteger(value) && value >= 0 && value < TOOL_NAMES.length;
}
